const fontShortHandProperties = [
  'font-style',
  // 'font-variant', // -> font-variant in canvas seems not tosupport newer properties then css 2
  'font-weight',
  // 'font-stretch' // -> font-stretch may only be a single keyword value.
  'font-size',
  'line-height',
  'font-family',
];

const pixelDensityDependantProperties = ['font-size', 'line-height'];

function getFontShorthandFromComputedStyle(style) {
  const props = Object.fromEntries(
    fontShortHandProperties.map(prop => [prop, style.getPropertyValue(prop)])
  );

  // set properties according to pixel density
  const mapPropToPixelRatio = prop => {
    if (props[prop]) {
      const [value, unit] = props[prop].split(/(\d+)/).filter(Boolean);
      props[prop] = value * window.devicePixelRatio + unit;
    }
  };
  pixelDensityDependantProperties.forEach(prop => mapPropToPixelRatio(prop));

  // see https://developer.mozilla.org/en-US/docs/Web/CSS/font#Syntax
  return (
    [props['font-style'], /*props['font-variant'],*/ props['font-weight']].join(' ') +
    ` ${props['font-size']}/${props['line-height']} ` +
    [/*props['font-stretch'],*/ props['font-family']].join(' ')
  );
}

export function extractCanvasStyles(canvas) {
  // extract styles from one label from css
  const style = window.getComputedStyle(canvas);

  return {
    color: style.getPropertyValue('color'),
    fontShorthand: getFontShorthandFromComputedStyle(style),
  };
}

export function drawTextToCanvas(text, canvasEl, fontDOMString, color, contextOptions) {
  // Canvas does officially not support the setting of font-feature-settings
  // https://github.com/whatwg/html/issues/3571
  //
  // We tried using the feature declaration in the fontface interface
  // https://drafts.csswg.org/css-font-loading/#fontface-interface
  // sadly neither of the declarations are supported ¯\_(ツ)_/¯
  //
  // const f = new FontFace('BentonSansNumeric', `url(${BentonSans})`, {
  //   // variant: 'tabular-nums', // this does not work
  //   // featureSettings: '"tnum"', // also this does not
  // });
  //
  // We could make numeric numbers work though.
  // See the css of the canvas to understand how we work around this.

  const context = canvasEl.getContext('2d');

  // set correct pixel density
  const scale = window.devicePixelRatio; // Change to 1 on retina screens to see blurry canvas.
  context.scale(scale, scale);

  // set font to same setting as set to canvas via css
  context.font = fontDOMString;

  // calculate how large our canvas has to be

  // 1) for the width we take the actual text drawn
  const { width } = context.measureText(text);

  // 2) for the height we count in all glyphs used in all labels,
  // so we don't have inconsistent alignment
  const lettersUsed = '0123456789,.';
  const { actualBoundingBoxAscent, actualBoundingBoxDescent } = context.measureText(lettersUsed);

  const height = actualBoundingBoxAscent + actualBoundingBoxDescent;

  canvasEl.height = height;
  canvasEl.width = width;

  // NOTE: We do not set this since the canvas texture uses the size of the canvas
  // Normalize coordinate system to use css pixels.
  // canvasEl.style.height = Math.floor(height / scale) + 'px';
  // canvasEl.style.width = Math.floor(width / scale) + 'px';

  // after canvas size changed we have to set the font again
  context.font = fontDOMString;
  context.fillStyle = color;

  if (contextOptions) Object.assign(context, contextOptions);

  context.fillText(text, 0, actualBoundingBoxAscent);
}
